import { createContext } from 'react';
import type { AuthResponse, AuthUser, LoginFormValues, RegisterCustomerFormValues } from './types';

export type AuthContextValue = {
  isAuthenticated: boolean;
  isBootstrapping: boolean;
  user: AuthUser | null;
  token: string | null;
  /// Signs in staff and buyers alike (#271); the role of the session says where it lands.
  login: (values: LoginFormValues) => Promise<AuthResponse>;
  /// Registers a customer and keeps the session when it comes back with one. `session` is null
  /// when the email claimed an account created at the counter: it is activated from the mail.
  registerCustomer: (
    values: RegisterCustomerFormValues,
  ) => Promise<{ email: string; session: AuthResponse | null }>;
  /// Activates a counter account from its invitation and keeps the session it returns.
  activateAccount: (values: {
    token: string;
    password: string;
    phone?: string;
  }) => Promise<AuthResponse>;
  /// Sets a new password from a reset link and keeps the session it returns (CTA-2).
  resetPassword: (values: { token: string; password: string }) => Promise<AuthResponse>;
  refreshUser: () => Promise<AuthUser | null>;
  logout: () => void;
};

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);
